import { BROKER_LINKS } from "@/data/brokers";

export function useBrokerUrl(brokerName: string): string {
  return BROKER_LINKS[brokerName] || '#';
}
